var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 54,
    viewBox: "0 0 28 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15034_2045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85692 10.2039L21.9201 10.2652C21.9201 10.2652 23.5439 10.5786 23.6082 8.31241C23.6726 6.0462 23.6082 2.45773 23.6082 2.45773C23.6082 2.45773 23.2971 -0.125536 20.2321 0.000564626C17.167 0.126665 6.41983 0.000564626 6.41983 0.000564626C6.41983 0.000564626 3.54437 0.631069 3.60874 2.89728C3.67312 5.16349 3.54794 8.56462 3.54794 8.56462C3.54794 8.56462 3.29759 10.1391 4.8605 10.2003L4.85692 10.2039Z",
    fill: "#5A3CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85794 10.2031C5.85794 10.2031 5.98311 14.0438 2.7965 17.571C0.983239 20.3416 0.482536 20.6551 0.232185 21.79C0.171386 23.3645 0.10701 48.2964 0.10701 48.2964C0.10701 48.2964 -0.579668 53.7728 4.98171 53.8989C10.5431 54.025 22.8568 53.8376 22.8568 53.8376C22.8568 53.8376 27.7959 54.1511 27.921 48.862C28.0462 43.573 27.9818 21.9125 27.9818 21.9125C27.9818 21.9125 27.9818 21.282 27.17 20.4029C26.0434 19.0194 23.919 15.5534 22.982 14.4221C22.4205 13.4781 21.7946 13.1611 21.4834 10.2031C17.1094 10.2644 5.85794 10.2031 5.85794 10.2031Z",
    fill: "#CFE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0468659 23.7432C0.0468659 23.7432 5.11111 25.0042 10.7977 23.491C15.8619 22.3561 18.3618 21.1599 22.11 22.1687C24.1736 22.547 27.9861 23.2388 27.9861 23.2388L27.9253 48.1707C27.9253 48.1707 28.5905 53.7336 22.861 53.838C17.0493 53.9858 5.5832 53.9858 5.5832 53.9858C5.5832 53.9858 -0.160568 54.6163 0.00752502 48.1095C0.0897833 41.5198 0.0504424 23.7432 0.0504424 23.7432H0.0468659Z",
    fill: "#7257D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2949 28.4231C24.2949 27.7267 23.7352 27.1621 23.0449 27.1621C22.3546 27.1621 21.7949 27.7267 21.7949 28.4231V43.739C21.7949 44.4354 22.3546 45 23.0449 45C23.7352 45 24.2949 44.4354 24.2949 43.739V28.4231Z",
    fill: "#AE9BF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15034_2045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass4);
export default __webpack_public_path__ + "static/media/glass4.7c03e4daed5598c569d293a49ff4ee6e.svg";
export { ForwardRef as ReactComponent };